export default __webpack_public_path__ + "static/media/CSMobile-Septiembre25.6a23174e.webp";